export const nl = {
  ErGingIetsMis:
    'Er is iets misgegaan bij het laden. Probeer het later opnieuw of neem contact op met de klantenservice.',
};
